import { render, staticRenderFns } from "./FeatureNote.vue?vue&type=template&id=6ea32e08"
import script from "./FeatureNote.vue?vue&type=script&lang=js"
export * from "./FeatureNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3576265037/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ea32e08')) {
      api.createRecord('6ea32e08', component.options)
    } else {
      api.reload('6ea32e08', component.options)
    }
    module.hot.accept("./FeatureNote.vue?vue&type=template&id=6ea32e08", function () {
      api.rerender('6ea32e08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FeatureNote.vue"
export default component.exports